import CampaignVote from "./CampaignVote";

export default CampaignVote;
